<template>
  <div>
    <div style="color:#f40;">
      若【确认签收】30天内不点击【回单确认】按钮,则自动将回单付金额置为0,可直接开具发票(发票金额不包含回单付金额)
    </div>
    <el-tabs v-model="activeName">
      <!-- 待申诉、申诉中、申诉完成 -->
      <el-tab-pane label="待打款" name="1">
        <tableReturn v-if="activeName === '1'" :returnPayStatus="0" />
      </el-tab-pane>
      <el-tab-pane label="打款中" name="2">
        <tableReturn v-if="activeName === '2'" :returnPayStatus="1" />
      </el-tab-pane>
      <el-tab-pane label="已打款" name="3">
        <tableReturn v-if="activeName === '3'" :returnPayStatus="2" />
      </el-tab-pane>
      <el-tab-pane label="全部" name="4">
        <tableReturn v-if="activeName === '4'" :returnPayStatus="''" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tableReturn from "./tableReturn.vue";
export default {
  name: "ReturnPayFee",
  components: {
    tableReturn
  },
  data() {
    return {
      activeName: "1"
    };
  },
  watch: {
    $route(to, form) {
      this.activeName = "1";
    }
  }
};
</script>
<style scoped></style>
